import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendNode, OdataOperation, OdataService } from '@mono-repo/odata';
import { CordovaDevicePluginService, Platform } from '@mono-repo/plugins';
// eslint-disable-next-line @nx/enforce-module-boundaries
import packageJson from '../../../../../package.json';

export interface IUpdateStatus {
  isUpdateRequired: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateGuard implements CanActivate {
  constructor(
    private readonly odataService: OdataService,
    private deviceService: CordovaDevicePluginService,
    private router: Router,
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.deviceService.getPlatform() !== Platform.BROWSER) {
      const version: string = packageJson.version;
      return this.odataService
        .get<IUpdateStatus>(new OdataOperation().Query('isUpdateRequired').FunctionRequest([{ version }]), {
          backendNode: BackendNode.PUBLIC,
        })
        .pipe(map((response) => (response.isUpdateRequired ? this.router.parseUrl('/updateRequired') : true)));
    } else {
      return true;
    }
  }
}
